import { Channel } from "@/config/channel"
import { triggerSurvey, TriggerType } from "./survey-utils"

export const SandsivSurveyIdSisal = {
  ThankYouPage: 15,
  Home: 17,
  Bonus: 18,
  PdvSignup: 23,
  TaxCode: 21,
  ResidenceAddress: 24,
  Contacts: 25,
  AccessData: 26,
  SelectDocument: 27,
  DocumentData: 28,
  TopupLimits: 29,
  TermsAndConditions: 30,
  RecapOcr: 31,
} as const

type SandsivSurveyIdSisalType =
  (typeof SandsivSurveyIdSisal)[keyof typeof SandsivSurveyIdSisal]

const apiUrl = "https://sisal-survey.sandsiv.com"

export function triggerSurveySisal(
  surveyId: SandsivSurveyIdSisalType,
  channel: Channel,
  triggerType: TriggerType,
  ipAddress: string | null,
  accountId?: string | null,
) {
  return triggerSurvey(
    apiUrl,
    surveyId,
    channel,
    triggerType,
    ipAddress,
    accountId,
  )
}

export function triggerSurveyBasedOnPathnameSisal(
  pathname: string,
  channel: Channel,
  triggerType: TriggerType,
  ipAddress: string | null,
) {
  const surveyId = getSurveyId(pathname)
  if (surveyId == null) return false
  return triggerSurvey(apiUrl, surveyId, channel, triggerType, ipAddress)
}

function getSurveyId(pathname: string): SandsivSurveyIdSisalType | null {
  switch (pathname) {
    case "/":
      return SandsivSurveyIdSisal.Home
    case "/codice-fiscale":
      return SandsivSurveyIdSisal.TaxCode
    case "/indirizzo-residenza":
      return SandsivSurveyIdSisal.ResidenceAddress
    case "/contatti":
      return SandsivSurveyIdSisal.Contacts
    case "/dati-di-accesso":
      return SandsivSurveyIdSisal.AccessData
    case "/bonus":
      return SandsivSurveyIdSisal.Bonus
    case "/dati-documento":
      return SandsivSurveyIdSisal.DocumentData
    case "/limiti-ricarica":
      return SandsivSurveyIdSisal.TopupLimits
    case "/termini-e-condizioni":
    case "/termini-e-condizioni-ocr":
      return SandsivSurveyIdSisal.TermsAndConditions
    case "/riepilogo-dati-ocr":
      return SandsivSurveyIdSisal.RecapOcr
    case "/registrazione-pdv":
      return SandsivSurveyIdSisal.PdvSignup
    case "/seleziona-documento/cliente":
      return SandsivSurveyIdSisal.SelectDocument
    default:
      return null
  }
}
